export { default } from '@i22/frontend-cms-utils/store'
